import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

const options = document.getElementById('g3d-fluid-options');
const root = document.querySelector('.g3d-configurator');
if (options && root && !options.dataset.ready) {
  options.dataset.ready = '1';
  root.classList.add('g3d-fluid-product');
  const form = root.querySelector('.g3d-buy-form');
  const checkout = root.querySelector('.g3d-checkout-price');
  const mainControls = root.querySelector('[id^="g3d-controls-"]');
  const buy = form.querySelector('[name="add"]');
  const variantInput = form.querySelector('[name="id"]');
  const variants = JSON.parse(options.querySelector('[data-variants]').textContent);
  const tubeImages = JSON.parse(options.querySelector('[data-tube-images]').textContent);
  const holderToggle = options.querySelector('[data-holder-toggle]');
  const tubesToggle = options.querySelector('[data-tubes-toggle]');
  const holderPanel = options.querySelector('#g3d-fluid-holder-panel');
  const tubesPanel = options.querySelector('#g3d-fluid-tubes-panel');
  const holderStatus = options.querySelector('[data-holder-status]');
  const holderControls = options.querySelector('[data-holder-controls]');
  const initialVariant = variants.find(v => v.id === options.dataset.selected) || variants[0];
  const palette = [['Bianco','#ffffff'],['Nero','#111111'],['Rosso','#e21b23'],['Arancione','#ff7a00'],['Giallo','#ffd400'],['Verde','#18a558'],['Blu','#1769ff'],['Azzurro','#29b6f6'],['Viola','#7e57c2'],['Rosa','#ff5ca8'],['Grigio','#8d8d8d']];
  let mainReady = false, holderReady = false, holderLoading = false;
  let selectedTube = tubeImages[0], selectedPart = 0;
  let meshes = [], holderColors = [], resizeHolder = () => {};
  const mainColors = Array(5).fill('Nero');
  let mainPart = 0;
  buy.disabled = true;
  checkout.before(options);
  options.hidden = false;
  holderToggle.checked = initialVariant.holder === 'Sì';
  tubesToggle.checked = initialVariant.tubes === 'Sì';
  form.querySelector('.g3d-fast-checkout')?.remove();
  const component = document.createElement('product-form-component');
  component.id = 'g3d-fluid-product-form';
  component.setAttribute('data-section-id', options.dataset.sectionId);
  component.setAttribute('data-product-id', options.dataset.productId);
  component.setAttribute('data-product-url', options.dataset.productUrl);
  component.setAttribute('data-quantity-default', '1');
  component.setAttribute('on:submit', '/handleSubmit');
  const live = document.createElement('div');
  live.className = 'visually-hidden';
  live.setAttribute('aria-live', 'assertive');
  live.setAttribute('role', 'status');
  live.setAttribute('ref', 'liveRegion');
  const error = document.createElement('span');
  error.className = 'hidden';
  error.setAttribute('ref', 'addToCartTextError');
  error.setAttribute('role', 'alert');
  error.innerHTML = '<span></span><span></span><span></span>';
  variantInput.setAttribute('ref', 'variantId');
  form.setAttribute('data-type', 'add-to-cart-form');
  form.append(error);
  const anchor = document.createComment('');
  form.before(anchor);
  component.append(live, form);
  anchor.replaceWith(component);

  function property(label, value, enabled = true) {
    let input = Array.from(form.querySelectorAll('[data-fluid-property]')).find(i => i.dataset.fluidProperty === label);
    if (!input) {
      input = document.createElement('input'); input.type = 'hidden';
      input.dataset.fluidProperty = label; input.name = 'properties[' + label + ']'; form.append(input);
    }
    input.value = value; input.disabled = !enabled;
  }
  function sync() {
    const variant = variants.find(v => v.holder === (holderToggle.checked ? 'Sì' : 'No') && v.tubes === (tubesToggle.checked ? 'Sì' : 'No'));
    holderPanel.hidden = !holderToggle.checked;
    tubesPanel.hidden = !tubesToggle.checked;
    holderToggle.setAttribute('aria-expanded', String(holderToggle.checked));
    tubesToggle.setAttribute('aria-expanded', String(tubesToggle.checked));
    if (!variant) { buy.disabled = true; return; }
    variantInput.value = variant.id;
    root.querySelectorAll('.g3d-price,.g3d-checkout-price-value').forEach(el => el.textContent = variant.formattedPrice);
    property('Raccogli tubi', holderToggle.checked ? 'Sì' : 'No');
    property('Tubi recupero fluidi', tubesToggle.checked ? 'Sì' : 'No');
    property('Colore tubi', selectedTube.name, tubesToggle.checked);
    holderColors.forEach((name, i) => property('Colore raccogli tubi parte ' + (i + 1), name, holderToggle.checked));
    buy.disabled = !variant.available || !mainReady || (holderToggle.checked && !holderReady);
    if (holderToggle.checked) {
      if (!holderReady && !holderLoading) loadHolder();
      requestAnimationFrame(resizeHolder);
    }
  }
  function selectTube(tube) {
    selectedTube = tube;
    options.querySelectorAll('[data-tube-name]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tubeName === tube.name)));
    const preview = options.querySelector('[data-tube-preview]');
    preview.src = tube.url; preview.alt = 'Tubi recupero fluidi ' + tube.name;
    options.querySelector('[data-tube-caption]').textContent = tube.name;
    property('Colore tubi', tube.name, tubesToggle.checked);
  }
  for (const tube of tubeImages) {
    const button = document.createElement('button'); button.type = 'button'; button.dataset.tubeName = tube.name;
    button.setAttribute('aria-label', tube.name); button.setAttribute('aria-pressed', 'false');
    const image = document.createElement('img'); image.src = tube.url; image.alt = tube.name; image.width = 110; image.height = 110;
    const label = document.createElement('span'); label.textContent = tube.name;
    button.append(image, label); button.addEventListener('click', () => selectTube(tube));
    options.querySelector('[data-tube-choices]').append(button);
  }
  holderToggle.addEventListener('change', sync);
  tubesToggle.addEventListener('change', sync);
  selectTube(selectedTube);
  function initializeMain() {
    const parts = mainControls.querySelectorAll('.g3d-part-btn');
    const black = mainControls.querySelector('.g3d-swatch[title="Nero"]');
    if (mainReady || !parts.length || !black) return;
    parts.forEach(part => { part.click(); black.click(); });
    parts[0].click();
    form.querySelectorAll('[data-g3d-property]').forEach(input => {
      input.name = 'properties[' + input.dataset.g3dProperty.replace('Colore parte', 'Colore recupero fluidi parte') + ']';
    });
    mainReady = true;
    mainObserver.disconnect();
    sync();
  }
  mainControls.addEventListener('click', event => {
    const part = event.target.closest('.g3d-part-btn');
    const swatch = event.target.closest('.g3d-swatch');
    if (part) mainPart = Number(part.dataset.partIndex);
    if (swatch) {
      mainPart = Number(mainControls.querySelector('.g3d-part-btn.is-active')?.dataset.partIndex || 0);
      mainColors[mainPart] = swatch.title;
    }
    mainControls.querySelectorAll('.g3d-swatch').forEach(b => {
      const active = b.title === mainColors[mainPart];
      b.classList.toggle('is-active', active); b.setAttribute('aria-pressed', String(active));
    });
    mainControls.querySelectorAll('.g3d-part-btn').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.partIndex) === mainPart)));
  });
  const mainObserver = new MutationObserver(initializeMain);
  mainObserver.observe(mainControls, {childList:true,subtree:true});
  initializeMain();
  sync();

  function selectPart(index) {
    selectedPart = index;
    holderControls.querySelectorAll('[data-holder-part]').forEach((b, i) => {b.classList.toggle('is-active', i === index); b.setAttribute('aria-pressed', String(i === index));});
    holderControls.querySelector('[data-holder-current]').textContent = 'Parte ' + (index + 1) + ' · ' + holderColors[index];
    holderControls.querySelectorAll('[data-holder-color]').forEach(b => {b.classList.toggle('is-active', b.dataset.holderColor === holderColors[index]); b.setAttribute('aria-pressed', String(b.dataset.holderColor === holderColors[index]));});
  }
  function buildHolderControls() {
    holderControls.innerHTML = '<div class="g3d-heading"><strong>Colore raccogli tubi</strong></div><p data-holder-current></p><div class="g3d-part-picker"></div><div class="g3d-palette"></div>';
    meshes.forEach((mesh, i) => {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'g3d-part-btn'; button.dataset.holderPart = String(i); button.textContent = 'Parte ' + (i + 1);
      button.addEventListener('click', () => selectPart(i)); holderControls.querySelector('.g3d-part-picker').append(button);
    });
    palette.forEach(([name, hex]) => {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'g3d-swatch'; button.title = name; button.dataset.holderColor = name;
      button.setAttribute('aria-label', name); button.style.setProperty('--g3d-color', hex); button.innerHTML = '<span></span>';
      button.addEventListener('click', () => {
        const mesh = meshes[selectedPart];
        (Array.isArray(mesh.material) ? mesh.material : [mesh.material]).forEach(m => {m.color.set(hex); m.needsUpdate = true;});
        holderColors[selectedPart] = name; selectPart(selectedPart); sync();
      }); holderControls.querySelector('.g3d-palette').append(button);
    });
    selectPart(0);
  }
  function loadHolder() {
    holderLoading = true; holderStatus.textContent = 'Caricamento raccogli tubi…';
    const viewer = options.querySelector('[data-holder-viewer]');
    let renderer;
    try { renderer = new THREE.WebGLRenderer({antialias:true,alpha:true}); }
    catch (e) {holderStatus.textContent = 'Anteprima 3D non disponibile su questo dispositivo.'; return;}
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 5000);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2)); renderer.outputColorSpace = THREE.SRGBColorSpace;
    viewer.append(renderer.domElement);
    scene.add(new THREE.HemisphereLight(0xffffff, 0x777777, 2.5));
    const key = new THREE.DirectionalLight(0xffffff, 3.1); key.position.set(100,-80,160); scene.add(key);
    const fill = new THREE.DirectionalLight(0xffffff, 1.2); fill.position.set(-120,100,80); scene.add(fill);
    const orbit = new OrbitControls(camera, renderer.domElement); orbit.enableDamping = true;
    let radius = 1, initialized = false;
    resizeHolder = () => {
      const rect = viewer.getBoundingClientRect(); if (!rect.width || !rect.height) return;
      camera.aspect = rect.width / rect.height; camera.updateProjectionMatrix(); renderer.setSize(rect.width, rect.height, false);
      if (!initialized && holderReady) {
        const halfFov = Math.min(THREE.MathUtils.degToRad(35) / 2, Math.atan(Math.tan(THREE.MathUtils.degToRad(35) / 2) * camera.aspect));
        camera.position.set(0, -0.05 * radius, radius / Math.sin(halfFov) * 1.15); orbit.target.set(0,0,0); orbit.update(); initialized = true;
      }
    };
    new GLTFLoader().load('https://cdn.shopify.com/3d/models/o/6d1840008bc2df52/raccogli_tubi_recupero_fluidi_15_.glb', gltf => {
      const model = gltf.scene;
      model.traverse(o => {
        if (!o.isMesh) return;
        o.material = Array.isArray(o.material) ? o.material.map(m => m.clone()) : o.material.clone();
        (Array.isArray(o.material) ? o.material : [o.material]).forEach(m => m.color.set('#111111'));
        meshes.push(o); holderColors.push('Nero');
      });
      scene.add(model); const box = new THREE.Box3().setFromObject(model); const sphere = box.getBoundingSphere(new THREE.Sphere()); radius = sphere.radius || 1;
      model.position.sub(box.getCenter(new THREE.Vector3())); camera.near = Math.max(radius / 1000, .01); camera.far = Math.max(radius * 40, 1000);
      holderReady = true; holderLoading = false; holderStatus.textContent = ''; buildHolderControls(); resizeHolder(); sync();
    }, undefined, () => { holderStatus.textContent = 'Errore nel caricamento del raccogli tubi. Ricarica la pagina oppure deseleziona l’optional.'; holderLoading = false; });
    new ResizeObserver(resizeHolder).observe(viewer);
    renderer.setAnimationLoop(() => {if (!holderPanel.hidden) {orbit.update(); renderer.render(scene, camera);}});
    resizeHolder();
  }
}
